window.$ = function (selector) {
    return document.querySelector(selector);
};
window.$$ = function (selector) {
    return Array.from(document.querySelectorAll(selector));
};
window.twEvents = {
    disableBarba: false
};
